<template>
  <no-auth-layout @back="goBack">
    <div class="flex flex-col gap-4 px-5 pt-[32px] md:max-w-[552px] md:mx-auto md:px-0">
      <!-- Main content with dashed border -->
      <div class="text-[#433D31] font-inter">
        <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
          Reset Email
        </div>
        <div class="text-[1rem] leading-[1.5rem] font-semibold">Fret not, we're here to help!</div>
        <div class="text-[1rem] leading-[1.5rem] font-semibold">
          Have you added your mobile number to the app before?
        </div>
      </div>
      <!-- Button options -->
      <div class="flex flex-col gap-4 w-full mt-4">
        <OptionButton
          text="Yes, pretty sure I have"
          :is-selected="selectedOption === 'reset'"
          @click="selectOption('reset')"
        />
        <OptionButton
          text="Hmm, I'm not sure..."
          :is-selected="selectedOption === 'support'"
          @click="selectOption('support')"
        />
      </div>

      <!-- Bottom button - only show when option is selected -->
      <BottomButton v-if="selectedOption" text="Next" @click="handleNext" class="mb-[32px]" />
    </div>
  </no-auth-layout>
</template>
<script>
import NoAuthLayout from '@/components/NoAuth.vue';
import OptionButton from '@/components/common/OptionButton.vue';
import BottomButton from '@/components/common/BottomButton.vue';

export default {
  components: {
    NoAuthLayout,
    OptionButton,
    BottomButton,
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    goToResetEmail() {
      this.$router.push('/forgot-email/reset');
    },
    goToSupport() {
      this.$router.push('/forgot-email/contact-us');
    },
    handleNext() {
      if (this.selectedOption === 'reset') {
        this.goToResetEmail();
      } else if (this.selectedOption === 'support') {
        this.goToSupport();
      }
    },
    goBack() {
      this.$router.push('/login');
    },
  },
};
</script>
